import React, { useState } from 'react';
import { withBillingWriteAccess } from 'contexts/adminAccess';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { UserDetails } from '../types';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  user: UserDetails;
  creditCardPaymentAllowed?: boolean;
}

const CardPaymentAllowButton = ({ user, creditCardPaymentAllowed }: Props) => {
  const { id: rolloId, billingUserId } = user;

  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);

  const handleAllowCardPayment = async () => {
    try {
      setLoading(true);

      const response = await dataProvider.update('updatePaymentOptions', {
        userId: rolloId,
        data: {
          userId: billingUserId,
          creditCardEnabled: !creditCardPaymentAllowed,
        },
      });

      refresh();

      return response;
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleAllowCardPayment}
      disabled={loading}
      className={classes.button}>
      {creditCardPaymentAllowed ? 'Disable' : 'Enable'}
    </Button>
  );
};

export default withBillingWriteAccess(CardPaymentAllowButton);
